import { render, staticRenderFns } from "./ModalTitle.vue?vue&type=template&id=563c7846&lang=pug&"
import script from "./ModalTitle.vue?vue&type=script&lang=ts&"
export * from "./ModalTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports